import { createAction, props } from '@ngrx/store';
import {
	CreateRebateGroupModel,
	ListOptionModel,
	RebateGroupModel,
	RebateGroupSearchModel,
	SearchRequest,
	SearchResponse,
	UpdateRebateGroupModel
} from '@twrx-api-models';
import { IPreLoadModel } from 'app/models/dto/pre-load-model';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';

export enum RebateGroupActions {
	LoadRebateGroup = '[RebateGroup] LoadRebateGroup',
	RebateGroupLoaded = '[RebateGroup] RebateGroupLoaded',

	PreLoadRebateGroup = '[RebateGroup] PreLoadRebateGroup',
	RebateGroupPreLoaded = '[RebateGroup] RebateGroupPreLoaded',
	PreLoadRebateGroupNotFound = '[RebateGroup] PreLoadRebateGroupNotFound',

	LoadRebateGroupById = '[RebateGroup] LoadRebateGroupById',
	LoadRebateGroupNotFound = '[RebateGroup] LoadRebateGroupNotFound',
	RebateGroupByIdLoaded = '[RebateGroup] RebateGroupByIdLoaded',

	CreateRebateGroup = '[RebateGroup] CreateRebateGroup',
	RebateGroupCreated = '[RebateGroup] RebateGroupCreated',

	UpdateRebateGroup = '[RebateGroup] UpdateRebateGroup',
	RebateGroupUpdated = '[RebateGroup] RebateGroupUpdated',

	DeleteRebateGroup = '[RebateGroup] DeleteRebateGroup',
	RebateGroupDeleted = '[RebateGroup] RebateGroupDeleted',

	LoadRebateGroupOptions = '[RebateGroup] LoadRebateGroupOptions',
	RebateGroupOptionsLoaded = '[RebateGroup] RebateGroupOptionsLoaded',

	ErrorOccurred = '[RebateGroup] ErrorOccurred'
}

export const loadRebateGroupList = createAction(
	RebateGroupActions.LoadRebateGroup,
	props<ActionRequestPayload<SearchRequest>>()
);

export const rebateGroupLoaded = createAction(
	RebateGroupActions.RebateGroupLoaded,
	props<ActionResponsePayload<SearchResponse<RebateGroupSearchModel>>>()
);

export const preLoadRebateGroupById = createAction(
	RebateGroupActions.PreLoadRebateGroup,
	props<ActionRequestPayload<IPreLoadModel<number>>>()
);

export const preLoadRebateGroupNotFound = createAction(
	RebateGroupActions.PreLoadRebateGroupNotFound
);

export const rebateGroupByIdPreLoaded = createAction(
	RebateGroupActions.RebateGroupPreLoaded,
	props<ActionResponsePayload<IPreLoadModel<RebateGroupModel>>>()
);

export const loadRebateGroupById = createAction(
	RebateGroupActions.LoadRebateGroupById,
	props<ActionRequestPayload<number>>()
);

export const loadRebateGroupNotFound = createAction(
	RebateGroupActions.LoadRebateGroupNotFound
);

export const rebateGroupByIdLoaded = createAction(
	RebateGroupActions.RebateGroupByIdLoaded,
	props<ActionResponsePayload<RebateGroupModel>>()
);

export const createRebateGroup = createAction(
	RebateGroupActions.CreateRebateGroup,
	props<ActionRequestPayload<CreateRebateGroupModel>>()
);

export const rebateGroupCreated = createAction(
	RebateGroupActions.RebateGroupCreated
);

export const updateRebateGroup = createAction(
	RebateGroupActions.UpdateRebateGroup,
	props<ActionRequestPayload<UpdateRebateGroupModel>>()
);

export const rebateGroupUpdated = createAction(
	RebateGroupActions.RebateGroupUpdated
);

export const deleteRebateGroup = createAction(
	RebateGroupActions.DeleteRebateGroup,
	props<ActionRequestPayload<number>>()
);

export const rebateGroupDeleted = createAction(
	RebateGroupActions.RebateGroupDeleted
);

export const loadRebateGroupOptions = createAction(
	RebateGroupActions.LoadRebateGroupOptions,
	props<ActionRequestPayload<void>>()
);

export const rebateGroupOptionsLoaded = createAction(
	RebateGroupActions.RebateGroupOptionsLoaded,
	props<ActionResponsePayload<ListOptionModel<number>[]>>()
);

export const errorOccurred = createAction(RebateGroupActions.ErrorOccurred);
